import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Dropdown } from "semantic-ui-react";
import HeaderMenu from "../../components/header/header_menu";
import { connect } from "react-redux";
import { logout } from "../../redux/actions/userAction";
import { translate } from "react-i18next";
import { setLocaleENG, setLocalePTR } from "../../redux/actions/localeAction";
import ReadAxios from "../../components/axiosComponent/read";
import { isEmpty } from "lodash";


const localesOptions = [
  {
    key: "en",
    text: "English",
    value: "en",
  },
  {
    key: "pt",
    text: "Portuguese",
    value: "pt",
  },
];

class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      key: "pt",
      value: "Portuguese",
    };
  }

  componentDidMount() {
    if (this.state.key !== this.props.locales.local) {
      this.setState(
        {
          key: this.props.locales.local,
          value: this.props.locales.local === "en" ? "English" : "Portuguese",
        },
        () => {
          this.props.i18n.changeLanguage(this.state.key);
        }
      );
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.key !== nextProps.locales.local) {
      this.setState(
        {
          key: nextProps.locales.local,
          value: nextProps.locales.local === "en" ? "English" : "Portuguese",
        },
        () => {
          this.props.i18n.changeLanguage(this.state.key);
        }
      );
    }
  }

  updateStateValue = (data) => {
    // TODO: make the data structure generic
    if (data.value === "en") {
      this.props.setENG(data.value);
    } else if (data.value === "pt") {
      this.props.setPTR(data.value);
    } else {
      this.setState(
        {
          key: data.value,
          value: data.value === "en" ? "English" : "Portuguese",
        },
        () => {
          this.props.i18n.changeLanguage(this.state.key);
        }
      );
    }
    setTimeout(() => {
      window.location.reload();
    }, 700);
  };

  render() {
    return (
      <React.Fragment>
        <div className="navigationMenu">
          <nav className="navbar navbar-expand-sm bg-white p-fixed-top w3-border-bottom">
            <span className="togbutton">
              {" "}
              <i
                data-toggle="modal"
                data-target="#exampleModal1"
                className=" fas fa-bars"
              ></i>
              &nbsp;&nbsp;{" "}
            </span>
            <Link className="icon_tracker" to="#">
              <img src="assets/svg/t_a.svg" width="25px" alt="scct icon" />{" "}
              <strong style={{ color: "#DB538F" }}>
                {" "}
                {this.props.t("app_name") || "Partner Allocation"}{" "}
              </strong>
            </Link>
            
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navigation"
              aria-controls="navigation"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <i className="fas fa-ellipsis-v w3-text-black"></i>
            </button>
            <div
              className="collapse navbar-collapse justify-content-end"
              id="navigation"
            >
              {/* <HeaderMenu /> */}
              {Number(localStorage.getItem("customerNumber")) == 1122 ? (
              <>
              <div className="w3-border p-1 w3-round">
                <Dropdown
                  floating
                  icon='world'
                  className='icon'
                  labeled
                  onChange={(name, data) => this.updateStateValue(data)}
                  text={this.state.value}
                  defaultValue={this.props.locales.local}
                  options={localesOptions}
                />
              </div>
              </>
            ) : (null)}
              
              <HeaderMenu />
              <Dropdown
                className="nav-link"
                trigger={
                  <span className="no-icon w3-small p-bold-500">
                    {this.props.t("welcome") || "Welcome "},
                    {/* {" Lucas Silva "} */} &nbsp;
                    {this.props.auth.userName}
                  </span>
                }
                options={[
                  {
                    key: "settings",
                    text: this.props.t("setting") || "Settings",
                  },
                  {
                    key: "sign-out",
                    text: this.props.t("sign_out") || "Sign Out",
                    onClick: this.props.logout,
                  },
                ]}
              />
              {/* <Dropdown
                button
                className="icon"
                selection
                labeled
                icon="world"
                options={localesOptions}
                search
                text={this.state.value}
                onChange={(name, data) => this.updateStateValue(data)}
              /> */}
              {/* <Dropdown
                selection
                className='icon w3-small'
                floating
                button
                labeled
                icon="world"
                options={localesOptions}
                text={this.state.value}
                onChange={(name, data) => this.updateStateValue(data)}
              /> */}
            </div>
          </nav>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ auth, locales }) => {
  localStorage.setItem("isloggedIn", auth.token);
  localStorage.setItem("customerNumber", auth.customerNo);
  localStorage.setItem("userId", auth.userId);
  localStorage.setItem("locales", locales.local)
  localStorage.setItem("userKey", auth.userKey);
  localStorage.setItem("vendorId", auth.vendorId);
  localStorage.setItem("role", auth.role);
  if (+auth.customerNo == 1122) {
    localStorage.setItem("timezone", 'America/Sao_Paulo');
  }
  else {
    localStorage.setItem("timezone", 'Asia/Calcutta');
  }
  if (auth.vendorId) {
    ReadAxios({ url: `transporterMaster/` + auth.vendorId })
      .then((res) => {
        localStorage.setItem("vendorCode", res.data.resultSet[0]['transporterCode']);

      })
      .catch((err) => console.log(err));
  }
  return { auth, locales };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(logout()),
    setENG: (locales) => dispatch(setLocaleENG(locales)),
    setPTR: (locales) => dispatch(setLocalePTR(locales)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate("dashboard")(Header));
